export default {
  fields: {
    discount: {
      label: 'Remise',
    },
    usage_threshold: {
      label: 'Montant minimum de commande',
    },
    max_discount: {
      label: 'Montant maximum de remise',
    },
  },
};
